
    import Vue from "vue";
    import {Component, Prop} from "vue-property-decorator";
    import VueButton from "./VueButton.vue";

    @Component({
        components: {VueButton}
    })
    export default class Modal extends Vue {
        //Props
        @Prop({ default: "medium", type: String }) readonly width: string;
        @Prop({ required: true, type: String }) readonly title: boolean;
        @Prop({default: true}) readonly shiftFocus: boolean;
        @Prop({default: true}) readonly isLight: boolean;

        private initialFocus = document.activeElement;

        mounted() {
            if (!this.shiftFocus)
                return;

            this.initialFocus = document.activeElement;
            setTimeout(() => {
                (<HTMLElement> this.$refs['modal-content']).focus();

                document.addEventListener('focusin', this.onFocusInEventHandler);
            }, 100);
        }

        onFocusInEventHandler = this.onFocusIn.bind(this);

        onFocusIn(e: FocusEvent) {
            e = e || <FocusEvent> window.event;
            let modalContent = <HTMLElement> this.$refs['modal-content'];
            if (!modalContent.contains(e.target as Node)) {
                modalContent.focus();
            }
        }

        beforeDestroy() {
            if (this.initialFocus !== null && (this.initialFocus instanceof HTMLElement)) {
                this.initialFocus.focus();
            }

            document.removeEventListener('focusin', this.onFocusInEventHandler)
        }
        
        //Methods
        handleClose() {
            this.$emit('close');
        }
    }
